(function () {
    'use strict';

    angular
        .module('wsl.core')
        .directive('wsl-onLastRepeat', onLastRepeat);

    onLastRepeat.$inject = [];

    /* @ngInject */
    function onLastRepeat() {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            if (scope.$last) {
                setTimeout(function () {
                    scope.$emit('wsl-onLastRepeat', element, attrs);
                }, 1);
            }
        }
    }
})();
